import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const LINK_CSKH = 'https://c168cskh.pages.dev/';

/**
 * Layout Component - Component layout chung cho toàn bộ ứng dụng
 * 
 * Component này cung cấp:
 * - Background chính cho tất cả các trang
 * - Các ảnh decor (left, right, logo)
 * - Nút back: ở home thì về link CSKH, ở trang khác thì quay lại trang trước
 * - Responsive design cho mobile và desktop
 * 
 * @param {React.ReactNode} children - Nội dung của các page được render bên trong layout
 */
function Layout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const isHome = location.pathname === '/';

  /**
   * Xử lý sự kiện click nút back
   * - Ở trang home (/): chuyển về trang CSKH 24/7
   * - Ở trang khác: quay lại trang trước (navigate -1)
   */
  const handleBackClick = () => {
    if (isHome) {
      window.location.href = LINK_CSKH;
    } else {
      navigate(-1);
    }
  };

  return (
    <>
      {/* Background layer cố định */}
      <div
        className="fixed inset-0 -z-10"
        style={{
          backgroundImage: "url('/bg/bg.png')",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
          width: "100%",
          height: "100%"
        }}
      />



      {/* Container chính với nội dung */}
      <div className="relative min-h-screen w-full flex flex-col justify-start items-center">
        {/* Ảnh decor bên trái - hiển thị ở góc dưới bên trái */}
        {/* Responsive: lg:250px, md:200px, mobile:150px */}
        {/* <img
          src='/bg/left.png'
          className='fixed left-0 bottom-1 lg:w-[250px] md:w-[200px] w-[150px] h-auto object-contain z-0'
          alt="background left"
        /> */}

        {/* Ảnh decor bên phải - hiển thị ở góc dưới bên phải */}
        {/* Responsive: lg:250px, md:200px, mobile:150px */}
        {/* <img
          src='/bg/right.png'
          className='fixed right-0 bottom-1 lg:w-[250px] md:w-[200px] w-[150px] h-auto object-contain z-0'
          alt="background right"
        /> */}

        {/* Nút back - hiển thị ở góc trên bên trái */}
        {/* z-10: đảm bảo nút luôn ở trên các ảnh decor */}
        <button 
          onClick={handleBackClick} 
          className="absolute left-2 md:left-4 top-2 md:top-4 z-10 cursor-pointer flex items-center gap-2 px-3 md:px-4 py-2 md:py-2.5 rounded-full bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white font-semibold text-xs md:text-sm shadow-lg hover:shadow-xl transition-all duration-300"
        >
          {/* Icon mũi tên trái */}
          <svg 
            className="w-4 h-4 md:w-5 md:h-5" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24" 
            xmlns="http://www.w3.org/2000/svg"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
          <span className="hidden md:inline">QUAY LẠI</span>
        </button>

        {/* Container cho nội dung chính của các page */}
        {/* z-10: đảm bảo nội dung luôn ở trên các ảnh background */}
        <div className="relative z-10 w-full max-w-[640px] max-[640px]:max-w-[480px] max-[480px]:max-w-[360px] md:px-5 px-2 mx-auto mb-10">
          {/* Logo chính - căn giữa ở phía trên */}
          {/* left-1/2 -translate-x-1/2: căn giữa theo chiều ngang */}
          {/* Responsive: lg:300px, md:250px, mobile:200px */}
          <img
            src='/bg/logo.png'
            className='lg:w-[200px] md:w-[150px] w-[100px] h-auto object-contain pt-5 md:pt-8 mx-auto mb-5'
            alt="logo"
          />
          {children}
        </div>
      </div>
    </>
  );
}

export default Layout;

